import React from 'react';
import Navbar from './components/Navbar';
import Header from './components/Header';
import About from './components/About';
import CarouselBitcoins from './components/CarouselBitcoins';
import Services from './components/Services';
import './App.css';

class App extends React.Component {
  state = { coins: [] };

  async componentDidMount() {
    const proxyUrl = 'https://cors-anywhere.herokuapp.com';
    const apiUrl =
      'https://min-api.cryptocompare.com/data/top/mktcapfull?limit=10&tsym=USD';

    try {
      const response = await fetch(apiUrl);
      const data = await response.json();
      this.setState({ coins: data.Data });
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    return (
      <div>
        <Navbar />
        <Header />
        <CarouselBitcoins coins={this.state.coins} />
        <Services
          type='services'
          title='Potenciá tus ahorros'
          subtitle='Tenemos un producto para cada una de tus necesidades financieras'
        />
        <About />
        <Services
          type='steps'
          title='¿Cómo operar en Bityuya?'
          subtitle='Hacemos de las cripto algo sencillo. Registrate y comenzá en minutos'
        />
      </div>
    );
  }
}

export default App;
